import React from 'react';

const GettingStarted = () => {
  return (
    <div className="help-section">
      <div className="section-header">
        <div className="icon">🚀</div>
        <h2>Getting Started with Zpost</h2>
      </div>
      
      <div className="section-grid">
        <div className="info-card">
          <h3>1. Create Your Zwallet</h3>
          <p>Start by creating your secure embedded Zwallet. This proprietary wallet is required for all Zpost ecosystem features.</p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Click "Create Zwallet" on landing page</li>
            <li>Set a strong password</li>
            <li>Save your recovery phrase securely</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>2. Claim Your .zpost.eth</h3>
          <p>Mint your unique .zpost.eth domain. This becomes your universal identity across the ecosystem.</p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Navigate to ENS App via left sidebar</li>
            <li>Click "Mint Subdomain"</li>
            <li>Choose your username (e.g., john.zpost.eth)</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>3. Start Using Zpost</h3>
          <p>Begin using Zpost Social, Zhat Messenger, Zearch, and all ecosystem apps.</p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Share posts on Zpost Social</li>
            <li>Chat via Zhat Messenger</li>
            <li>Search with Zearch</li>
            <li>Manage assets with Zwallet</li>
          </ul>
        </div>
      </div>
      
      <div className="warning-box">
        <h4><span>⚠️</span> Important Note</h4>
        <p style={{ color: 'var(--text-light)', margin: 0 }}>
          You need a .zpost.eth domain to access the full Zpost ecosystem. No other ENS domains are supported.
        </p>
      </div>
    </div>
  );
};

export default GettingStarted;
